import { useState, useCallback } from 'react';

export function useModal(): [boolean, () => void] {
    const [open, setOpen] = useState(false);

    const toggle = useCallback(() => {
        setOpen(prev => !prev);
    }, []);

    return [open, toggle];
}
